<template>
    <div>
        <v-form ref="reference" v-model="valid">
            <v-row justify="center">
                <v-col cols="12" sm="12" md="6" lg="6">
                    <v-row justify="center">
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="First Name *" v-model="reference.FirstName" :rules="this.$parent.notEmpty" outlined></v-text-field>
                        </v-col>
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="Last Name *" v-model="reference.LastName" :rules="this.$parent.notEmpty" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="School Name *" v-model="reference.School__c" :disabled="true" outlined></v-text-field>
                        </v-col>
                         <v-col class="col-6">
                            <v-text-field class="text-field" label="Title / Role at school *" v-model="reference.What_is_their_role_at_your_school__c" :disabled="true" :rules="this.$parent.isRequired" outlined></v-text-field>
                        </v-col>                       
                    </v-row>
                    <v-row justify="center">
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="Email *" v-model="reference.Email" :rules="this.$parent.isEmail" outlined></v-text-field>
                        </v-col>
                         <v-col class="col-6">
                            <v-text-field class="text-field" label="Phone *" v-model="reference.Phone" :rules="this.$parent.notEmpty" outlined></v-text-field>
                        </v-col>                       
                    </v-row>
                    <v-row justify="center" style="margin-top: 20px">
                        <v-col class="col-12">
                            <v-select class="text-field" :items="[1,2,3,4,5,6,7,8,9,10,11,12]" v-model="reference.How_Many_Years_know_the_applicant__c" :rules="this.$parent.isRequired" label="Years you have known the applicant *" outlined></v-select>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col class="col-12">
                            <v-select class="text-field" :items="[1,2,3,4,5,6,7,8,9,10,11,12]" v-model="reference.How_Many_Years_Applicant_In_The_School__c" :rules="this.$parent.isRequired" label="Years student has been at this school *" outlined></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12">
                            <p class="question-field">Please complete the following:</p>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col class="col-6">
                            <p class="question-field">Actual attendance rate for this student *</p>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field class="text-field" type="number" label="%" v-model="reference.AttendancePct__c" :rules="lessthan100" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col class="col-6">
                            <p class="question-field">Number of days late/partial days *</p>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field class="text-field" type="number" label="days" v-model="reference.Absent_Days_Partial__c" :rules="largethan0" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col class="col-6">
                            <p class="question-field">Number of whole days absent *</p>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field class="text-field" type="number" label="days" v-model="reference.Absent_Days_Whole__c" :rules="largethan0" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12" style="margin-top: 30px">
                            <div class="question-field">Do you endorse this student for a GO-PEF Scholarship? *</div>
                            <v-radio-group v-model="reference.Endorsement__c" :value="reference.Endorsement__c" :rules="this.$parent.isRequired" row>
                            <v-radio class="radio-button-field" color="#ea7f1d" label="Yes" value="Yes" :style="reference.Endorsement__c == 'Yes' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio class="radio-button-field" color="#ea7f1d" label="No" value="No" :style="reference.Endorsement__c == 'No'? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row v-if="reference.Endorsement__c == 'Yes' || reference.Endorsement__c == 'No'">
                        <v-col class="col-12">
                            <div class="question-field" v-if="reference.Endorsement__c == 'No'">Please let us know why you don’t endorse this student for a GO Scholarship? *</div>
                            <div class="question-field" v-if="reference.Endorsement__c == 'Yes'">Please provide a supporting statement for this student *</div>
                            <v-textarea class="text-area" outlined counter v-model="reference.Endorsement_Reason__c" ref="endoseReason" :rules="this.lengthCheck"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row style="margin-top: 40px">
                        <v-col v-if="reference.Endorsement__c == 'Yes'" class="col-12">
                            <div class="question-field">We understand the diversity of circumstances that our students come from but please list any other factors that you are aware of that may contribute to less than positive outcomes for this student? *</div>
                            <v-textarea class="text-area"  outlined v-model="reference.Circumstances_make_it_harder_for_child__c" :rules="this.$parent.isRequired" messages="e.g. lack of attendance, poor academic performance, poor behaviour, suspensions/expulsions, drug or alcohol usage etc."></v-textarea>
                        </v-col>
                    </v-row>
                    <!--
                    <v-row style="margin-top: 40px">
                        <v-col v-if="reference.Endorsement__c == 'Yes'" class="col-12"> -->
                            <!-- <div class="declaration-title">Declaration *</div> -->
                            <!--
                            <v-input class="declaration-title" v-model="reference.Guardian_Parents_Declaration_Signed__c" :rules="[v=>v || 'Please agree with the declaration to proceed']">Declaration *</v-input>
                            <div style="display: flex">
                                <v-checkbox class="declaration-checkbox" color="#ea7f1d" v-model="reference.Guardian_Parents_Declaration_Signed__c" :rules="[v=>!!v]"></v-checkbox>
                                <div class="declaration-clause">
                                    The school is fully supportive of this application. We understand that the GO Scholarship will involve an element of administration from the school and agree and acknowledge the following:<br><br>
                                    a. agree to inviting CareerTrackers into the school to support GO students both in their school to university transition and for work experience. We understand that we can make this support available to all Indigenous students in the school;<br><br>
                                    b. send the student’s school reports, NAPLAN results and other similar information relating to their academic and extra-curricular activities to GO each year of the scholarship; and<br><br>
                                    c. supporting the attendance of GO Scholars at GO events, including Mentoring Days and Graduation Ceremonies.
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    -->
                </v-col>
            </v-row>
        </v-form>
        <v-row class="row-height-80" justify="center">
            <v-col class="col-6 row-height-80">
                <button v-if="!submitting" :disabled="!valid || submitting" :style="cssVars" class="submit-button submit-button-text" @click="submitReference">SUBMIT REFERENCE</button>
                <button v-else class="submit-button submit-button-text"><span class="spin">&bull;</span></button>
            </v-col>
        </v-row>
        <v-dialog persistent v-model="showerr" class="mx-auto" max-width="410">
            <v-card class="dialog-style dialog-margin">
                
                <div class="tips">
                    <p class="dialog-header">Something Went Wrong</p>
                    <p style="color:#4d4d4d;font-weight:bold;">Your submittion is failed due to an error, please reopen the link and try again. </p>
                    <br>
                    <p style="color:#4d4d4d;font-weight:bold;">If you continue having this issue, please click the "Support" button at right bottom of the screen to contact a GO supportor for help. </p>
                    <br>
                </div>
                <v-card-actions class="margin-top">
                    <v-btn large color="#ea7f1d" class="popup-button leave-button" @click="showerr = false"><span class="leave">GO BACK</span></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    data: function() {
        return {
            valid: false,
            submitting: false,
            endorse_reason_min: 300,
            endorse_reason_max: 1000,
            showerr: false,
            count:"",
        }
    },
    watch: {
        'reference.Endorsement__c': function(val) {

            this.endorse_reason_min = val == 'No' ? 400 : 300;
            this.endorse_reason_max = val == 'No' ? 700 : 1000;
            this.$refs['endoseReason'].validate();
            
        }
    },
    computed: {
        reference() {
            return this.$parent.reference
        },
        lengthCheck() {
            return  [v => !v ? !!v || 'The field cannot be empty': v.length >= this.endorse_reason_min && v.length <= this.endorse_reason_max || `Answer length: ${this.endorse_reason_min} min - ${this.endorse_reason_max} max (characters)`] 
        },
        cssVars() {
            return {
                '--submit-button-color': this.valid ? '#ea7f1d' : '#d5d5d5',
                '--submit-button-text-color': this.valid ? '#ffffff' : '#8e8e8c'
            }
        },
        
        lessthan100(){
            return [v => v.length > 0 || 'This field may not be empty',
                    v => (v > 0 && v < 101) || 'The value must be between 1 to 100']
        },
        largethan0(){
            return [v => v.length > 0 || 'This field may not be empty',
                    v => v > 0 || 'The value must be large than 0'
                    ]
        },
    },
    methods:{
        async submitReference(){

            this.submitting = true;
            if(!this.$refs['reference'].validate()){
                this.submitting = false;
                setTimeout(() => {
                    const el = document.getElementsByClassName('error-text')[0];
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 500)
                return
            }
            /*
            this.reference['Feedback_Submitted__c'] = true;            
            let re = '';
            re = this.promise1();
            console.log('submit result');
            console.log(re);
            if(re == '500'){
                this.showerr = true;
            }else{
                this.$parent.submitted = true;
            }
            */


            
            this.reference['Feedback_Submitted__c'] = true;
            this.$store.commit('reference/updateData', {key: 'exception', payload: ''});
            await this.$parent.saveReference();

            this.threeGo();

            //this.$parent.submitted = true;
            
        },
        /*
        promise1() {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        this.$parent.saveReference();
                        if(this.$store.getters['reference/exception'] != '') {
                            reject ('500');
                        } else {
                            resolve ('200') 
                        }
                    }, 1000)
                })
        }
        */
        threeGo(){
            const TIME_COUNT = 5;
            if(!this.timer){
                this.count = TIME_COUNT;
                this.show = false;
                console.log('log promise');
                this.timer = setInterval(()=>{
                if(this.count > 0 && this.count <= TIME_COUNT){
                    console.log(this.$store.getters['reference/apiresult']);

                    console.log(this.$store.getters['reference/exception']);
                    if(this.$store.getters['reference/exception'] != ''){
                        if(this.$store.getters['reference/exception'] == 200){
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.$parent.submitted = true;
                        }else if(this.$store.getters['reference/exception'] == 500){
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.showerr = true;
                        }
                    }
                    /*
                    if(this.$store.getters['reference/apiresult']){

                    }*/
                    this.count--;
                }else{
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                    //this.$parent.submitted = true;
                }
            },1000)
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.primary-font{
    font-family: Hind;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
}

.text-field {
    @extend .primary-font;
    height: 65px;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: -0.15px;
    color: #6a6a66;
}

.radio-button-field
{
    @extend .text-field;
    height: 24px;
    line-height: 1.5;
    letter-spacing: normal;
    color: '#3a3a3a';
}

.text-area
{
    @extend .primary-font;
}

.question-field{
    @extend .primary-font;
    font-size: 16px;
    line-height: 1.44;
    letter-spacing: normal;
    color: black;
    margin-bottom: 10px;
}

.declaration-title
{
    @extend .primary-font;
    font-weight: bold;
    line-height: 1.44;
    letter-spacing: normal;
    color: black;
}

.declaration-checkbox
{
    width: 20px;
    height: 20px;
    margin: 0
}

.declaration-clause{
    @extend .primary-font;
    line-height: 1.44;
    letter-spacing: normal;
    margin-left: 20px;
    margin-top: 4px;
}

.submit-button
{
    width: 100%;
    height: 53px;
    border-radius: 3px;
    background-color: var(--submit-button-color);
    margin-top: 30px;
} 

.submit-button-text
{
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    text-align: center;
    color: var(--submit-button-text-color);
}

.spin {
    color: white;
    display: flex;
    justify-content: center;
    -webkit-animation: dotting 2s infinite;
    -o-animation: dotting 2s infinite;
    animation: dotting 2s infinite;
}
.dialog-style{
    width: 408px;
    height: 410px;
}
.tips{
    padding: 40px 38px 20px 30px;
    width: 408px;
    height: 320px;
    font-family: Hind;
}
.popup-button{
  width: 160px;
  height: 53px;
  border-radius: 3px;
  margin: 0 auto 0px auto;
}
.leave-button{
  background-color: #ea7f1d;
}
.go-back-button{
    border: solid 2px #4d4d4d;
}
.leave{
    width: 130px;
    height: 23px;
    @extend .form-secondary-text;
    color: #ffffff;
}
.go-back {
    width: 119px;
    height: 23px;
    @extend .form-secondary-text;
    color: #4d4d4d;
}
.form-secondary-text{
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
}
.margin-top {
    margin-top: 20px;
}
.dialog-header
{
    height: 75px;
    font-family: Dosis;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 3.2px;
    text-align: center;
    color: black;
    padding-top: 40px;
    margin-bottom: 20px;

}

@keyframes dotting {
    0% {
        text-shadow: 0 0 0 currentColor;
    }
    33% {
        text-shadow: -20px 0 0 currentColor;
    }
    66% {
        text-shadow: -20px 0 0 black, 20px 0 0 currentColor;
    }
    100% {
        text-shadow: 0px 0 0 currentColor;
    }
}

</style>
